import { Fragment, useEffect, useState } from "react";
import { connect } from "react-redux";
import { Field } from "react-final-form";
import _ from "lodash";
import { getProductionStrumisWorkOrderProductionProcesses } from "modules/production/strumis/production/work_order_processes/actions";
import { getProductionStrumisContractMarkInstancesFinal } from "../actions";
import { OnChange } from "react-final-form-listeners";
import { SmartSelect } from "modules/4_final_form/mobile";
import { Block, BlockTitle, Button, List, Preloader } from "framework7-react";

function mapStateToProps(state) {
  return {
    production_strumis_production_work_order_processes: state.production_strumis_production_work_order_processes,
    production_strumis_contract_mark_instances: state.production_strumis_contract_mark_instances,
  };
}

const SelectMarkInstances = (props) => {
  const [loading, setLoading] = useState(false);
  const {
    production_strumis_production_work_order_processes,
    production_strumis_contract_mark_instances,
    filters,
    strumis_contracts,
    option_label,
    name,
    label,
    filterByStageTitle,
  } = props;

  const filterByStage = filters?.production_stage_id ? true : false;
  const [showByStage, setShowByStage] = useState(filterByStage);

  useEffect(() => {
    if (showByStage) {
      props.getProductionStrumisWorkOrderProductionProcesses({ strumis_contracts, ...filters }).then(() => setLoading(false));
    } else {
      props.getProductionStrumisContractMarkInstancesFinal({ strumis_contracts, ...filters }).then(() => setLoading(false));
    }
    setLoading(true);
  }, []);

  let mark_instances_options;
  if (showByStage) {
    mark_instances_options = getProductionStageMarkInstances(
      production_strumis_production_work_order_processes,
      filters.production_stage_id,
      option_label
    );
  } else {
    mark_instances_options = _.sortBy(
      _.map(production_strumis_contract_mark_instances, (mi) => {
        if (option_label) {
          return {
            label: option_label(mi),
            value: mi.strumis_mark_instance_id,
            ...mi,
          };
        } else {
          return {
            label: `${mi?.mark} - Phase ${mi?.phase} - Lot ${mi?.lot} - ${mi?.guid?.substring(0, 4)}`,
            value: mi.strumis_mark_instance_id,
            ...mi,
          };
        }
      }),
      "mark"
    );
  }

  return (
    <Fragment>
      {loading && (
        <div className="text-center">
          <Preloader />
        </div>
      )}
      {!loading && (
        <Fragment>
          <Block>
            <BlockTitle>{showByStage ? filterByStageTitle : "Showing all marks"}</BlockTitle>
          </Block>
          <List>
            <Field
              component={SmartSelect}
              name={name}
              label={label}
              searchbar
              searchbarPlaceholder="Search Mark"
              options={mark_instances_options}
              labelName="label"
              valueName="value"
              virtualList
              slot="list"
              {...props}
            />
          </List>
          <Block>
            {showByStage && filterByStage && (
              <Button
                fill
                color="green"
                className="ml-5"
                onClick={() => {
                  setLoading(true);
                  props.getProductionStrumisContractMarkInstancesFinal({ strumis_contracts }).then(() => setLoading(false));
                  setShowByStage(false);
                }}
              >
                Show All Marks
              </Button>
            )}
            {!showByStage && filterByStage && (
              <Button
                fill
                className="ml-5"
                onClick={() => {
                  setLoading(true);
                  props.getProductionStrumisWorkOrderProductionProcesses({ strumis_contracts, ...filters }).then(() => setLoading(false));
                  setShowByStage(true);
                }}
              >
                Show Marks By Stage
              </Button>
            )}
          </Block>
          <OnChange name={name}>
            {(selectedValue) => {
              if (props.onChange) {
                const mark_instances = showByStage ? production_strumis_production_work_order_processes : production_strumis_contract_mark_instances;
                props.onChange(
                  selectedValue,
                  _.find(mark_instances, (mi) => mi.strumis_mark_instance_id == selectedValue),
                  mark_instances
                );
              }
            }}
          </OnChange>
        </Fragment>
      )}
    </Fragment>
  );
};

export default connect(mapStateToProps, { getProductionStrumisWorkOrderProductionProcesses, getProductionStrumisContractMarkInstancesFinal })(
  SelectMarkInstances
);

const getProductionStageMarkInstances = (production_strumis_production_work_order_processes, production_stage_id, option_label) => {
  const mark_instances_filtered = _.filter(production_strumis_production_work_order_processes, (mi) => mi.production_stage_id == production_stage_id);
  const group_by_guid = _.groupBy(mark_instances_filtered, "guid");

  const filtered_by_stage = _.filter(group_by_guid, (mi) => _.some(mi, (bd) => bd.process_status == "in_progress"));
  const flatten_by_stage = _.flatten(filtered_by_stage);
  const by_stage = _.uniqBy(flatten_by_stage, "guid");

  const mark_instances_options = _.sortBy(
    _.map(by_stage, (mi) => {
      if (option_label) {
        return {
          label: option_label(mi),
          value: mi.strumis_mark_instance_id,
          ...mi,
        };
      } else {
        return {
          label: `${mi?.mark} - Phase ${mi?.phase} - Lot ${mi?.lot} - ${mi?.guid?.substring(0, 4)}`,
          value: mi.strumis_mark_instance_id,
          ...mi,
        };
      }
    }),
    "mark"
  );

  return mark_instances_options;
};
